import { render } from "./UeExpensesEditView.vue?vue&type=template&id=5adff70c&scoped=true&ts=true"
import script from "./UeExpensesEditView.vue?vue&type=script&lang=ts"
export * from "./UeExpensesEditView.vue?vue&type=script&lang=ts"

import "./UeExpensesEditView.vue?vue&type=style&index=0&id=5adff70c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adff70c"]])

export default __exports__